import { PlatformUserConversions } from "./PlatformUserConversions";

// TODO: this will need to diverge at some point
export class PlatformUserAdminConversions extends PlatformUserConversions {}
